import React, { useState, useEffect } from "react";
import { Amplify, Auth, Hub } from "aws-amplify";
import { makeStyles } from "@material-ui/core/styles";
import config from "./aws-exports";
import { msalToken, ForgotPasswordApiCall, GetAppTempleateData, IsUserExists, UnlockAccount, registerNewUserAPI, accountVerificationAPI, checkVerificationAPI } from "../js/utilities";
import { modifyToken, modifyTokenZendesk, getCurrentSessionIdToke, logout } from "./authModule";
import jwt from "jsonwebtoken";
import envConfig from "../environment/config";
import { AppType } from "../constant/appType";
import CompnayAppLogo from '../assets/images/carrier_header.png';//Company Logo
import ComapnyBgImage from '../assets/images/backgroundImage.png';
import { defaultTemplate } from '../constant/constant';
import NewSignUpForm from "./Components/signup/newSignUpForm";
import CCRSignUpForm from "./CCRComponents/CCRSignUpForm";
import CCRSignInForm from "./CCRComponents/CCRSignInForm";
import CCRForgotPassword from "./CCRComponents/CCRForgotPassword";
import CCRResetPassword from "./CCRComponents/CCRResetPassword";
import CCRAccountVerification from "./CCRComponents/CCRAccountVerification";
import CSS_Logo_New from './../assets/images/CSS_Logo_New.png';

const useStyles = makeStyles((theme) => ({
  root1: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
      height: "100vh"
    },
    root: {
      height: "100%",
      width: "100%"
    },
    display: "inline-block",
    background: "#e0e8e8",
    padding: "60px 80px 60px 60px",
    "margin-top": "50px",
  },
  buttonstyle: {
    margin: "4px",
    width: "220px",
  },
  spanStyle: {
    background: "#0033ab",
    color: "white",
    "font-family": "Poppins,sans-serif",
    "padding-left": "4px",
    "padding-right": "4px"
  }
}));

const LoginWrapper = (props) => {
  const initialFormState = {
    username: "",
    password: "",
    confirmPassword: "",
    email: "",
    authCode: "",
    given_name: "",
    family_name: "",
    formType: "loading",
    oid: "",
    region: 'EMEA',
    "custom:country": "",
    "custom:state": "",
    "custom:city": "",
    confirmatinCode: ""
  };

  const regionDetails = {
    "EMEA": {
      country: 'France',
      state: 'Ile de France',
      city: 'Paris',
    },
    "North America": {
      country: 'United States of America',
      state: 'New York',
      city: 'New York',
    },
    "Asia": {
      country: 'India',
      state: 'Telangana',
      city: 'Hyderabad',
    }
  }

  const { decode } = jwt;
  // const [showSignInForm, setShowSignInForm] = useState(false);
  const [formState, updateFormState] = useState(initialFormState);
  const [userEmail, setUserEmail] = useState("");
  const [signInError, setSignInError] = useState("");
  // const [registerError, setRegisterError] = useState("");
  const [signInUnReq, setSignInUnReq] = useState("");
  const [signInPwdReq, setSignInPwdReq] = useState("");
  const [forgotPassword, setForgotPassword] = useState("");
  const [forgotPwdStatus, setForgotPwdStatus] = useState("");
  const [signInStatus, setSignInStatus] = useState("");
  const [registerStatus, setRegisterStatus] = useState("");
  const [verificationStatus, setVerificationStatus] = useState("");
  const [disableRegisterBtn, setDisableRegisterBtn] = useState(false);
  const [showForgotPwdLinkWhileRegister, setShowForgotPwdLinkWhileRegister] = useState(false);
  const [internalSignUpStatus, setInternalSignUpStatus] = useState("");
  const [appConfig, setAppConfig] = useState({});
  // const [appTemplate, setAppTemplate] = useState({ backgroundImage: "" });
  // const [appLogo, setAppLogo] = useState("");
  // const [fontColor, setFontColor] = useState({});
  const [customTemplate, setCustomTemplate] = useState({});
  const [noOfAttempts, setNoOfAttempts] = useState(5);
  const classes = useStyles();

  const getConfigObject = (params) => {
    if (params.get('appConfig')) {
      let apiUrl = params.get('apiUrl')
      let domain = params.get('domain')
      let clientId = params.get('clientId')
      let identityPoolId = params.get('identityPoolId')
      let userPoolId = params.get('userPoolId')
      let uiUrl = params.get('uiUrl')
      let postLogOutUri = params.get('postLogOutUri')
      let appType = params.get('appType');
      let isLatestAuth = params.get('isLatestAuth');
      let appClientId = params.get('appClientId');
      let isInternalLoginOnly = params.get('isInternalLoginOnly')

      const appConfig = {
        "apiUrl": apiUrl ? decodeURIComponent(apiUrl) : null,
        "uiUrl": uiUrl ? decodeURIComponent(uiUrl) : null,
        "userPoolId": userPoolId ? decodeURIComponent(userPoolId) : config.aws_user_pools_id,
        "identityPoolId": identityPoolId ? decodeURIComponent(identityPoolId) : config.aws_cognito_identity_pool_id,
        "clientId": clientId ? decodeURIComponent(clientId) : config.aws_user_pools_web_client_id,
        "domain": domain ? decodeURIComponent(domain) : config.oauth.domain,
        "postLogOutUri": postLogOutUri ? decodeURIComponent(postLogOutUri) : config.oauth.redirectSignIn,
        "appType": appType ? decodeURIComponent(appType) : null,
        "isLatestAuth": isLatestAuth ? decodeURIComponent(isLatestAuth) : null,
        "appClientId": decodeURIComponent(appClientId),
        "isInternalLoginOnly": isInternalLoginOnly ? decodeURIComponent(isInternalLoginOnly) : 'true',
      }

      localStorage.setItem('applicationConfig', JSON.stringify(appConfig));
      return appConfig;
    }

    return {}
  }

  useEffect(() => {
    async function initialSetup() {
      const params = new URLSearchParams(window.location.search);
      let appConfigData = getConfigObject(params);
      setAppConfig(appConfigData);

      GetAppTempleateData(appConfigData, function (response) {
        setCustomTemplate({
          appImage: (response == null || response.appImage == null || response.appImage === '') ?
            CompnayAppLogo : response.appImage,
          bgImage: {
            backgroundImage: (response == null || response.bgImage == null || response.bgImage === '') ?
              `url(${ComapnyBgImage})` : `url(${response.bgImage})`
          },
          fontColor: {
            color: (response == null || response.color == null || response.color === '' || response.color === 'string') ?
              `${defaultTemplate.color}` : `${response.color}`
          }
        });
      });

      let isLogout = params.get('isLogout')
      if (isLogout) {
        updateFormState(() => ({ ...formState, formType: "loading" }));
        logout(appConfigData)
      }

      const newConfig = {
        ...config,
        'aws_user_pools_id': appConfigData.userPoolId || config.aws_user_pools_id,
        'aws_cognito_identity_pool_id': appConfigData.identityPoolId || config.aws_cognito_identity_pool_id,
        'aws_user_pools_web_client_id': appConfigData.clientId || config.aws_user_pools_web_client_id,
        // 'oauth': {
        //   ...config.oauth,
        //   "domain": appConfigData.domain || config.oauth.domain
        // }
        Auth: {
          ...config.oauth,
          "domain": appConfigData.domain || config.oauth.domain
        }
      };

      Amplify.configure(newConfig);

      let mailaddress = params.get('emailAddress');
      if (mailaddress) {
        setUserEmail(mailaddress);
        updateFormState(() => ({ ...formState, username: mailaddress }));
      }

      let isSignUp = params.get('isSignUp');
      let isNewUserRegster = params.get('isRegisterExternalUser');
      let resetPassword = params.get('reset-password');
      let accountUnlock = params.get('account-unlock');

      if (isSignUp) {
        updateFormState(() => ({ ...formState, formType: "signUp" }));
      } else if (isNewUserRegster) {
        updateFormState(() => ({
          ...formState,
          formType: "isRegisterExternalUser",
          username: params.get('emailAddress'),
          given_name: params.get('FirstName'),
          family_name: params.get('LastName'),
          "custom:country": params.get('Country'),
          "custom:state": params.get('State'),
          "custom:city": params.get('City'),
        }));
      } else if (resetPassword) {
        let confirmatinCode = params.get('confirmation_code');
        let username = params.get('user_name');
        updateFormState(() => ({ ...formState, username: username, confirmatinCode: confirmatinCode, formType: "resetPassword" }));
      } else if (accountUnlock) {
        let confirmatinCode = params.get('confirmation_code');
        if (confirmatinCode != null && confirmatinCode !== undefined && confirmatinCode !== '') {
          //Unlock the account
          await UnlockAccount(params.get('email_address'), confirmatinCode, true, "", async function (response) {
            const appConfigData = localStorage.getItem('applicationConfig') == null ? {} : JSON.parse(localStorage.getItem('applicationConfig'));
            window.location.href = `${window.location.origin}?apiUrl=${encodeURIComponent(appConfigData.apiUrl || envConfig.api.development)}&uiUrl=${encodeURIComponent(appConfigData.uiUrl || envConfig.ui.development)}&redirectAppUri=${encodeURIComponent(window.location.origin)}&appType=${appConfigData.appType}`;
          });
        } else {
          login();
        }
      } else {
        login();
      }
    }

    initialSetup();
    setAuthListener();
  }, []);

  const setAuthListener = async () => {
    Hub.listen("auth", async (data) => {
      const appConfigData = JSON.parse(localStorage.getItem('applicationConfig')); // use appConfig from here for api call
      switch (data.payload.event) {
        case "signOut":
          updateFormState(() => ({ ...formState, formType: "signIn" }));
          break;
        case "oAuthSignOut":
          updateFormState(() => ({ ...formState, formType: "signIn" }));
          break;
        case "signIn":
          updateFormState(() => ({ ...formState, formType: "loading" }));
          let currentToken = await getUserToken();
          let mToken = await modifyTokenCall(appConfigData, currentToken)
          localStorage.setItem(msalToken, mToken);
          const { country, given_name, family_name, username, usertype, hvacusername, emails } = decode(mToken);
          if (country) {
            let newUrl = "";
            let appIdParam = "";
            //console.log(appConfigData.appClientId);
            if (appConfigData.appClientId) {
              appIdParam = `&appClientId=${appConfigData.appClientId}`;
            }
            if (appConfigData.isLatestAuth) {
              newUrl = `${appConfigData.postLogOutUri}?apiUrl=${encodeURIComponent(appConfigData.apiUrl)}&uiUrl=${encodeURIComponent(appConfigData.uiUrl)}&redirectAppUri=${encodeURIComponent(window.location.origin)}${appIdParam}&umtoken=${localStorage.getItem("msal.idtoken")}`;
            } else {
              newUrl = `${appConfigData.postLogOutUri}?umtoken=${localStorage.getItem("msal.idtoken")}`;
            }
            window.location.href = newUrl;
          }
          else {
            if (JSON.parse(localStorage.getItem('applicationConfig')).postLogOutUri.indexOf("zendesk") !== -1) {
              const { iat } = decode(mToken);
              if (diff_minutes(new Date(), EpochToDate(iat)) < 3) {
                const newUrl = `${appConfigData.postLogOutUri}${localStorage.getItem("msal.idtoken")}`;
                window.location.href = newUrl;
              }
              else {
                updateFormState(() => ({ ...formState, formType: "signIn" }));
              }
            }
            else {
              if (usertype === envConfig.awsIDP) {
                updateFormState(() => ({ ...formState, formType: "internalSignUp", given_name: given_name, family_name: family_name, username: username }));
              } else if (usertype === "Google") {
                setUserEmail(emails[0]);
                updateFormState(() => ({ ...formState, formType: "socialSignUp", given_name: given_name, family_name: family_name, username: username }));
              } else {
                updateFormState(() => ({ ...formState, formType: "hvacSignUp", username: hvacusername, 'custom:country': 'USA' }));
              }
            }
          }
          break;
        case "signUp":
          break;
        case "parsingCallbackUrl":
          break;
        case "signIn_failure":
          break;
        case "configured":
          break;
        default:
          // setShowSignInForm(false);
          break;
      }
    });
  }

  const getUserToken = async () => {
    let currentToken = await getCurrentSessionIdToke();
    return await currentToken
  };

  const modifyTokenCall = async (appConfigData, currentToken) => {
    let mToken = null;
    if (JSON.parse(localStorage.getItem('applicationConfig')).postLogOutUri.indexOf("zendesk") !== -1) {
      mToken = modifyTokenZendesk(currentToken);
    }
    else {
      mToken = await modifyToken(appConfigData, currentToken);
    }
    return await mToken
  }

  function EpochToDate(epoch) {
    if (epoch < 10000000000)
      epoch *= 1000; // convert to milliseconds (Epoch is usually expressed in seconds, but Javascript uses Milliseconds)
    var epoch = epoch + (new Date().getTimezoneOffset() * -1); //for timeZone        
    return new Date(epoch);
  }
  function diff_minutes(dt2, dt1) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
  }

  const login = async () => {
    const appConfigData = JSON.parse(localStorage.getItem('applicationConfig'));
    try {
      const currentToken = await getUserToken();
      let mToken = await modifyTokenCall(appConfigData, currentToken)
      if (!localStorage.getItem(msalToken)) {
        if (!mToken) {
          updateFormState(() => ({ ...formState, formType: "signIn" }));
        }
      } else {
        let newUrl = "";
        let appIdParam = "";
        if (appConfigData.appClientId) {
          appIdParam = `&appClientId=${appConfigData.appClientId}`;
        }

        if (appConfigData.isLatestAuth) {
          newUrl = `${appConfigData.postLogOutUri}?apiUrl=${encodeURIComponent(appConfigData.apiUrl)}&uiUrl=${encodeURIComponent(appConfigData.uiUrl)}&redirectAppUri=${encodeURIComponent(window.location.origin)}${appIdParam}&umtoken=${localStorage.getItem("msal.idtoken")}`;
        } else {
          newUrl = `${appConfigData.postLogOutUri}?umtoken=${localStorage.getItem("msal.idtoken")}`;
        }

        if (JSON.parse(localStorage.getItem('applicationConfig')).postLogOutUri.indexOf("zendesk") !== -1) {
          if (mToken) {
            const { iat } = decode(mToken);
            if (diff_minutes(new Date(), EpochToDate(iat)) < 3) {
              newUrl = `${appConfigData.postLogOutUri}${localStorage.getItem("msal.idtoken")}`;
              window.location.href = newUrl;
            } else {
              displaySignIn();
            }
          } else {
            displaySignIn();
          }
        } else {
          const { country, given_name, family_name, username, usertype, hvacusername, emails } = decode(localStorage.getItem("msal.idtoken"));
          if (country) {
            //console.log("LoginMethod----->", newUrl);
            window.location.href = newUrl;
          }
          else {
            if (usertype === envConfig.awsIDP) {
              updateFormState(() => ({ ...formState, formType: "internalSignUp", given_name: given_name, family_name: family_name, username: username }));
            } else if (usertype === "Google") {
              setUserEmail(emails[0]);
              updateFormState(() => ({ ...formState, formType: "socialSignUp", given_name: given_name, family_name: family_name, username: username }));
            } else {
              updateFormState(() => ({ ...formState, formType: "hvacSignUp", username: hvacusername, 'custom:country': 'USA' }));
            }
          }
        }
      }
      // code to redirect or show signIn page
    } catch (error) {
      console.log(error);
      displaySignIn();
      // Code to handle Hvac user .  Hvac user logic has Oid. Please confirm
    }
  };

  const displaySignIn = () => {
    updateFormState(() => ({ ...formState, formType: "signIn" }));
  }

  const onChange = (e) => {
    e.persist();
    updateFormState(() => ({ ...formState, [e.target.name]: e.target.value }));
  }

  const onCheck = (e) => {
    e.persist();
    updateFormState(() => ({ ...formState, [e.target.name]: e.target.checked }));
  }

  const onCancel = () => {
    updateFormState(() => ({ ...formState, username: "", password: "" }));
  }

  const { formType } = formState;

  const signIn = async () => {
    const { username, password } = formState;
    try {
      setSignInUnReq("");
      setSignInPwdReq("");
      setSignInError("");
      setSignInStatus("");

      let isFormValid = true;
      if (username === undefined || username.trim() === "") {
        setSignInUnReq("Please enter your email");
        isFormValid = false;
      } else {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(username)) {
          setSignInUnReq("Please enter a valid email address");
          isFormValid = false;
        }
      }

      if (password === undefined || password.trim() === "") {
        setSignInPwdReq("Please enter your password");
        isFormValid = false;
      }

      if (isFormValid) {
        setSignInStatus("Please wait while validating...");

        await checkVerificationAPI(appConfig, username, async (response) => {
          if (response) {
            try {
              const user = await Auth.signIn({ username, password });
              updateFormState(() => ({ ...formState, formType: "loading" }));
              setSignInStatus("");
            } catch (error) {
              if (error.code.indexOf("NotAuthorizedException") !== -1 || error.message.indexOf("Incorrect") !== -1) {
                console.log(error.code);
                await UnlockAccount(username, '', false, appConfig.appType, async function (response) {
                  setSignInStatus("");
                  if (response != null && response.noOfAttempts < 5) {
                    setSignInError(`Your credentials is incorrect. You have ${noOfAttempts - response.noOfAttempts} attempts left.`);
                  } else if (response == null || response.toString().indexOf("authorized") !== -1) {
                    setSignInError("If you don't remember it press forgot password.");
                  } else {
                    setSignInError("Account locked due to too many failed attempts. Please check your email for further instructions.");
                  }
                });
              } else if (error.message.indexOf("instructions") !== -1) {
                setSignInStatus("");
                setSignInError("Account locked due to too many failed attempts. Please check your email for further instructions");
              } else if (error.message.indexOf("disabled") !== -1) {
                setSignInStatus("");
                setSignInError("Your account is disabled.");
              } else if (error.message.indexOf("exceeded") !== -1) {
                setSignInStatus("");
                setSignInError("Signin attempts exceeded. Please try after some time.");
              } else if (error.message.indexOf("User does not exist") !== -1) {
                try {
                  const user = await Auth.signIn({ username, password });
                } catch (e) {
                  setSignInStatus("");
                  if (error.code.indexOf("NotAuthorizedException") !== -1) {
                    setSignInError("Your password is incorrect");
                  } else if (error.code.indexOf("UserNotFoundException") !== -1) {
                    setSignInError("We can't seem to find your account");
                  }
                }
              } else if (error.code.indexOf("UserNotFoundException") !== -1) {
                setSignInStatus("");
                if (error.message.indexOf("Bad password") !== -1) {
                  setSignInError("We can't seem to find your account. Please contact the administrator");
                } else {
                  setSignInError("We can't seem to find your account");
                }
              }
            }
          }
        }, (err) => {
          if (err.response.data.includes('User Not Found')) {
            setSignInError("We couldn't find an account with that email.");
          } else if (err.response.data.includes('User Verification pending')) {
            setSignInError("Please check your emails and verify your account before login first time.");
          } else {
            setSignInError("An error occured while verifying your account. Please try later.");
          }
        });

      }
    } catch (error) {
      console.log(error);
    }
  }

  const register = async () => {
    setDisableRegisterBtn(true);
    const { username, given_name, family_name, region } = formState;
    try {
      setSignInUnReq("");
      // setRegisterError("");
      setRegisterStatus("");

      let isFormValid = true;

      if (username === undefined || username.trim() === "") {
        setSignInUnReq("Please enter your email");
        isFormValid = false;
      } else {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(username)) {
          setSignInUnReq("Please enter a valid email address");
          isFormValid = false;
        }
      }

      if (isFormValid) {
        setRegisterStatus("Please wait while validating...");

        let payload = {
          "UPN": username,
          "firstname": given_name,
          "lastname": family_name,
          "region": region,
          "CountryName": regionDetails[region].country,
          "State": regionDetails[region].state,
          "City": regionDetails[region].city,
          "emailAddress": username,
          "IsActive": "true",
          "IsManager": "false",
          "IsAppManager": "false",
          "ObjectId": null,
          "DesktopUserID": null,
          "UserType": 0,
          "langCode": "8",
          "IsGroupUserDisable": "false",
          "UnifyId": null,
          "IsFirstSignUp": "false",
          "hasExternaloginOnly": "false"
        }

        try {
          await registerNewUserAPI(appConfig, payload, (response) => {
            if (response) {
              setShowForgotPwdLinkWhileRegister(false);
              // setDisableRegisterBtn(false);
              if (username.split('@')[1].toLowerCase().trim() === 'ccr.com') {
                setRegisterStatus("Registered Successfully !!!. Admin will contact you to activate your account.");
              } else {
                signUp();
              }
            }
          }, (err) => {
            setDisableRegisterBtn(false);
            if (err.response.data.message.includes('Existing Internal User already registered but didnot logged in')) {
              setRegisterStatus("Registered Successfully !!!. Admin will contact you to activate your account.");
              setShowForgotPwdLinkWhileRegister(false);
            } else if (err.response.data.message.includes('Existing External User already registered but didnot logged in')) {
              setRegisterStatus("The email ID you entered, already linked to an existing account. Please check your email to login.");
              setShowForgotPwdLinkWhileRegister(false);
            } else if (err.response.data.message.includes('User already exist or invited in Group')) {
              setRegisterStatus("The email ID you entered, already linked to an existing account. Do you want to ");
              setShowForgotPwdLinkWhileRegister(true);
            } else if (err.response.data.message.includes('Internal User already exists.')) {
              setShowForgotPwdLinkWhileRegister(false);
              setRegisterStatus("You are an Internal User. Please select Internal Sign In on home page.");
              localStorage.setItem('usertype', '');
            } else if (err.response.data.message.includes('User already exist or invited other than Default Group.')) {
              setShowForgotPwdLinkWhileRegister(false);
              setRegisterStatus("User is already invited. Please check your email to proceed with next steps.");
            }
          });
        } catch (error) {
          console.log(error);
        }
      }

    } catch (error) {
      console.log(error);
    }
  }

  const NotificationForgotPassword = async () => {
    setForgotPassword("");
    setForgotPwdStatus("Please wait while processing...");

    const { email } = formState;
    try {
      await ForgotPasswordApiCall(appConfig, { "email": email, "userType": 1, "appType": appConfig.appType, "apiUrl": appConfig.apiUrl, "uiUrl": appConfig.uiUrl, "appClientId": appConfig.appClientId }, function (response) {
        setForgotPwdStatus("");
        if (response) {
          window.location.href = `${appConfig.postLogOutUri || window.location.origin}${getUrlWithoutSlash(appConfig.postLogOutUri)}`;
        }
        else {
          setForgotPwdStatus("Forgot password is unsuccessful. Please verify email is correct.");
        }
      });
    }
    catch (error) {
      setForgotPwdStatus("We couldn't find an account with that email.");
      setForgotPassword("");
      console.log(error);
    }
  }

  const getUrlWithoutSlash = (url) => {
    if (!url) return '/';
    if (url[(url.length) - 1] === '/') return '';
    return '/'
  }

  const createGuid = () => {
    let S4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    let guid = `${S4()}${S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`;
    return guid.toLowerCase();
  }

  const signUp = async () => {
    // setDisableRegisterBtn(true);
    setInternalSignUpStatus("Please wait while we process your information...");
    updateFormState(() => ({ ...formState, username: userEmail }));
    const { password, given_name, family_name, username, region, 'custom:country': country, 'custom:state': state, 'custom:city': city } = formState;


    //Verify user already exists
    await IsUserExists(appConfig, userEmail && userEmail !== '' ? userEmail : username, "1", async function (response) {
      if (response == null || response === undefined) {
        const userId = createGuid();
        await Auth.signUp({
          'username': userId,
          password, attributes: {
            'email': userEmail && userEmail !== '' ? userEmail : username,
            given_name,
            family_name,
            'custom:region': appConfig.appType === AppType.CSS ? region : '',
            'custom:country': appConfig.appType === AppType.CSS ? regionDetails[region].country : country,
            'custom:state': appConfig.appType === AppType.CSS ? regionDetails[region].state : state,
            'custom:city': appConfig.appType === AppType.CSS ? regionDetails[region].city : city
          }
        })

        if (appConfig.appType === AppType.CSS) {
          setInternalSignUpStatus("Sign Up Completed !!! Please check your email to verify your account.");
          setDisableRegisterBtn(false);
        } else {
          const { username } = formState;
          const payload = {
            "email": userEmail && userEmail !== '' ? userEmail : username,
            "userType": 1, //ExternalUserType
            "isVerifyAccess": true,
            "objectId": null
          }
          await accountVerificationAPI(appConfig, payload, async (response) => {
            if (response) {
              updateFormState(() => ({ ...formState, formType: "loading" }));
              setInternalSignUpStatus("Success!! Logging in to AppsHub...");
              setDisableRegisterBtn(false);
              await Auth.signIn(userId, password);
            }
          });
        }
      } else {
        setDisableRegisterBtn(false);
        setInternalSignUpStatus("User is already Signed up. Please do Cancel and SignIn.");
      }
    });
  }

  const confirmPassword = async () => {
    setForgotPwdStatus("Please wait while processing...");
    const { username, confirmatinCode, password } = formState;
    try {
      await ForgotPasswordApiCall(appConfig, { "email": username, "userType": 1, "password": password, "verificationCode": confirmatinCode }, function (response) {
        const newUrl = `${appConfig.postLogOutUri || window.location.origin}${getUrlWithoutSlash(appConfig.postLogOutUri)}`;
        window.location.href = newUrl;
      });
    }
    catch (error) {
      setForgotPwdStatus("Error occurred. Please try again.");
      console.log(error);
    }
  }

  const CompanySignIn = async () => {
    try {
      // setShowSignInForm(false);
      const user = await Auth.federatedSignIn({ provider: envConfig.awsIDP });//Provider name from cognito
      updateFormState(() => ({ ...formState, formType: "loading" }));
    } catch (error) {
      console.log("error signing in", error);
    }
  }

  const HvacSignIn = async () => {
    // setShowSignInForm(false);
    await Auth.federatedSignIn({ provider: envConfig.awsHVACIDP });
  }

  const ForgotPassword = async () => {
    setShowForgotPwdLinkWhileRegister(false);
    updateFormState(() => ({ ...formState, formType: "forgotPassword" }));
  }

  const CSSNewUserRegister = async () => {
    updateFormState(() => ({ ...formState, formType: "newUserRegister" }));
  }

  const OnForgotPasswordCancel = () => {
    updateFormState(() => ({ ...formState, formType: "signIn" }));
  }

  const onAccountVerification = async () => {
    setVerificationStatus("Verifying your account...");
    const { username } = formState;
    const payload = {
      "email": username,
      "userType": 1, //ExternalUserType
      "isVerifyAccess": true,
      "objectId": null
    }
    try {
      await accountVerificationAPI(appConfig, payload, function (response) {
        if (response) {
          setVerificationStatus("Successfully verified your account. Please Sign In.")
        }
      });
    }
    catch (error) {
      setVerificationStatus("Unable to verify your account.");
      console.log(error);
    }
  }

  return (
    <div className={classes.root} style={{ minHeight: '100vh', background: formType === "loading" ? '' : 'radial-gradient(100% 133% at -3% 95%, #11A271 0%, #132E4D 100%)' }}>
      {appConfig.appType === AppType.CSS && formType !== "loading"
        ? <div style={{ display: 'flex', justifyContent: 'center', padding: '5% 0px 30px 0px' }} >
          <img style={{ maxWidth: '320px' }} src={CSS_Logo_New} alt="CSS_LOGO" />
        </div>
        : null
      }
      {formType === "loading" && (!localStorage.getItem(msalToken)) && (
        <center>
          <span className={classes.spanStyle}>
            Loading...
          </span>
        </center>
      )}
      {formType === "signIn" && (
        <CCRSignInForm
          customTemplate={customTemplate}
          CompanySignIn={CompanySignIn}
          signInStatus={signInStatus}
          signInError={signInError}
          signInUnReq={signInUnReq}
          signInPwdReq={signInPwdReq}
          ForgotPassword={ForgotPassword}
          HvacSignIn={HvacSignIn}
          signIn={signIn}
          CSSNewUserRegister={CSSNewUserRegister}
          onChange={onChange}
          appConfig={appConfig}
          onCancel={onCancel}
        />
      )}
      {formType === "signUp" && appConfig.appType !== AppType.CSS && (
        <NewSignUpForm userEmail={userEmail} customTemplate={customTemplate} signUp={signUp} appConfig={appConfig} formState={formState} onChange={onChange} onCheck={onCheck} internalSignUpStatus={internalSignUpStatus} />
      )}
      {(formType === "newUserRegister") && appConfig.appType === AppType.CSS
        ? <CCRSignUpForm
          formType={formType}
          appConfig={appConfig}
          formState={formState}
          showForgotPwdLinkWhileRegister={showForgotPwdLinkWhileRegister}
          CompanySignIn={CompanySignIn}
          register={register}
          ForgotPassword={ForgotPassword}
          disableRegisterBtn={disableRegisterBtn}
          signUp={signUp}
          onChange={onChange}
          registerStatus={registerStatus}
          internalSignUpStatus={internalSignUpStatus}
        />
        : null
      }
      {(formType === "isRegisterExternalUser") && appConfig.appType === AppType.CSS
        ? <CCRAccountVerification
          formType={formType}
          appConfig={appConfig}
          formState={formState}
          verificationStatus={verificationStatus}
          verifyAccount={onAccountVerification}
        />
        : null
      }
      {
        formType === "forgotPassword" && (
          <CCRForgotPassword
            customTemplate={customTemplate}
            NotificationForgotPassword={NotificationForgotPassword}
            forgotPassword={forgotPassword}
            forgotPwdStatus={forgotPwdStatus}
            appConfig={appConfig}
            formState={formState}
            onChange={onChange}
            cancel={OnForgotPasswordCancel}
          />
        )}
      {formType === "resetPassword" && (
        <CCRResetPassword
          customTemplate={customTemplate}
          resetPwdStatus={forgotPwdStatus}
          confirmPassword={confirmPassword}
          appConfig={appConfig}
          formState={formState}
          onChange={onChange}
        />
      )}
    </div>
  );
}

export default LoginWrapper;
